<template>
  <div>
    <div class="settings-option-buttons">
      <button
        class="firstOption"
        @click="settingsOption = false"
        v-bind:class="{ 'active':  !settingsOption }"
      >
        Profile Details
      </button>
      <button
        class="secondOption"
        @click="settingsOption = true"
        v-bind:class="{ 'active':  settingsOption }"
      >
        Security
      </button>
    </div>

    <!-- Loader Component -->
    <Loader
      v-if="loading"
    />

    <div class="settings-views" v-if="!loading">
      <div class="applicant-details-option-holder" v-if="!settingsOption">
        <div class="applicant-details-option">
          <div class="container-left">

            <!-- Image Uploader Component -->
            <image-upload
              v-bind:title="'Profile'"
            />

            <div class="input-holder">
              <div class="header">
                <h3>First Name</h3>
              </div>
              <input
                type="text"
                name="firstName"
                :value="firstName"
                @change="validateText"
              />
              <p v-if="error.firstNameError" class="error">Please enter a valid input</p>
            </div>

            <div class="input-holder">
              <div class="header">
                <h3>Last Name</h3>
              </div>
              <input
                type="text"
                name="lastName"
                :value="lastName"
                @change="validateText"
              />
              <p v-if="error.lastNameError" class="error">Please enter a valid input</p>
            </div>

            <div class="input-holder">
              <div class="header">
                <h3>Email Address</h3>
              </div>
              <input
                type="text"
                name="emailAddress"
                :value="emailAddress"
                @change="validateText"
                disabled
              />
              <p v-if="error.emailAddressError" class="error">Please enter a valid input</p>
            </div>

            <div class="input-holder">
              <div class="header">
                <h3>Address</h3>
              </div>
              <input
                type="text"
                name="address"
                :value="address"
                @change="validateText"
              />
              <p v-if="error.addressError" class="error">Please enter a valid input</p>
            </div>

            <div class="input-holder">
              <div class="header">
                <h3>Phone Number</h3>
              </div>
              <input
                type="text"
                name="phone"
                placeholder="e.g. +14131854138 or 4131854138"
                :value="phone"
                @change="validateText"
              />
              <p v-if="error.phoneError" class="error">Please enter a valid input</p>
            </div>

            <div class="input-holder">
              <div class="header">
                <h3>Bio</h3>
              </div>
              <textarea
                name="bio"
                :value="bio"
                @change="validateText"
                placeholder="Add a bio of yourself"
              >
              </textarea>
              <p v-if="error.bioError" class="error">Please enter a valid input</p>
            </div>

          </div>

          <div class="container-right">
            <div class="input-holder">
              <div class="header">
                <h3>Role</h3>
              </div>
              <input
                type="text"
                name="role"
                placeholder="e.g. Software Engineer"
                :value="role"
                @change="validateText"
              />
              <p v-if="error.roleError" class="error">Please enter a valid input</p>
            </div>

            <div class="input-holder">
              <div class="header">
                <h3>Nationality</h3>
              </div>
              <input
                type="text"
                name="country"
                placeholder="e.g. Nigeria"
                :value="country"
                @change="validateText"
              />
              <p v-if="error.countryError" class="error">Please enter a valid input</p>
            </div>

            <div class="state-and-city-holder">
              <div class="input-holder">
                <div class="header">
                  <h3>State/Province</h3>
                </div>
                <input
                  type="text"
                  name="state"
                  placeholder="e.g. Ontario"
                  :value="state"
                  @change="validateText"
                />
                <p v-if="error.stateError" class="error">Please enter a valid input</p>
              </div>

              <div class="input-holder">
                <div class="header">
                  <h3>City</h3>
                </div>
                <input
                  type="text"
                  name="city"
                  placeholder="e.g. Toronto"
                  :value="city"
                  @change="validateText"
                />
                <p v-if="error.cityError" class="error">Please enter a valid input</p>
              </div>
            </div>

            <!-- CV and Video Upload Component -->
            <applicant-cv-video
              v-on:selectedFile="selectedFile"
              v-on:selectedCVError="setCvErrorStatus"
              v-on:selectedVideoError="setVideoErrorStatus"
            />

          </div>
        </div>

        <div class="buttons">
            <button class="cancel-btn">Cancel</button>
            <button @click="handleProfileUpdate()" class="update-btn">Save</button>
        </div>

      </div>

      <div class="security-option" v-if="settingsOption">
        <div class="wrapper">
          <!-- Password Change Component -->
          <password-change
            v-on:closePasswordSettings="closePasswordSettings()"
            v-on:logout="$emit('logout')"
          />
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import ApplicantCvVideo from '../../components/body/ApplicantCvVideo.vue';
import ImageUpload from '../../components/body/ImageUpload.vue';
import Loader from '../../components/body/Loader.vue';
import PasswordChange from '../../components/body/PasswordChange.vue';

export default {
  name: 'ApplicantProfileSettings',
  components: {ImageUpload, PasswordChange, Loader, ApplicantCvVideo},
  data() {
    return {
      settingsOption: false,
      loading: false,
      formData: {
        firstName: null,
        lastName: null,
        emailAddress: null,
        address: null,
        phone: null,
        bio: null,
        role: null,
        country: null,
        state: null,
        city: null,
        selectedVideoFile: null,
        selectedCvFile: null
      },
      error: {
        firstNameError: false,
        lastNameError: false,
        emailAddressError: false,
        addressError: false,
        phoneError: false,
        bioError: false,
        roleError: false,
        countryError: false,
        stateError: false,
        cityError: false,
      },
      selectedCVError: false,
      selectedVideoError: false
    };
  },
  computed: {
    firstName() {
      if(this.$store.state.userData.firstName && !this.formData.firstName){
        return this.$store.state.userData.firstName;
      } else {
        return this.formData.firstName;
      }
    },
    lastName() {
      if(this.$store.state.userData.lastName && !this.formData.lastName){
        return this.$store.state.userData.lastName;
      } else {
        return this.formData.lastName;
      }
    },
    emailAddress() {
      if(this.$store.state.userData.emailAddress && !this.formData.emailAddress){
        return this.$store.state.userData.emailAddress;
      } else {
        return this.formData.emailAddress;
      }
    },
    address() {
      if(this.$store.state.userData.address && !this.formData.address){
        return this.$store.state.userData.address;
      } else {
        return this.formData.address;
      }
    },
    phone() {
      if(this.$store.state.userData.phone && !this.formData.phone){
        return this.$store.state.userData.phone;
      } else {
        return this.formData.phone;
      }
    },
    bio() {
      if(this.$store.state.userData.bio && !this.formData.bio){
        return this.$store.state.userData.bio;
      } else {
        return this.formData.bio;
      }
    },
    role() {
      if(this.$store.state.userData.role && !this.formData.role){
        return this.$store.state.userData.role;
      } else {
        return this.formData.role;
      }
    },
    country() {
      if(this.$store.state.userData.country && !this.formData.country){
        return this.$store.state.userData.country;
      } else {
        return this.formData.country;
      }
    },
    state() {
      if(this.$store.state.userData.state && !this.formData.state){
        return this.$store.state.userData.state;
      } else {
        return this.formData.state;
      }
    },
    city() {
      if(this.$store.state.userData.city && !this.formData.city){
        return this.$store.state.userData.city;
      } else {
        return this.formData.city;
      }
    },
  },
  methods: {
    handleProfileUpdate(){
      if(
        this.error.firstNameError ||
        this.error.lastNameError ||
        this.error.emailAddressError ||
        this.error.addressError ||
        this.error.phoneError ||
        this.error.bioError ||
        this.error.roleError ||
        this.error.countryError ||
        this.error.stateError ||
        this.error.cityError ||
        this.selectedCVError ||
        this.selectedVideoError
      ) {
        null;
      } else {
        this.loading = true;
        this.$store
        .dispatch('updateProfile', [
          this.formData,
          this.selectedImage,
          this.$store.state.userData.userType
        ])
        .then((res) => {
          this.loading = false;
          if ( res && res.response) {
            this.$store.dispatch('fetchUserData')
            .then(() => {
              this.$toastr.success(res.response, 'Success');
            });
          } else if (res && res.error) {
            this.$toastr.error(res.error.errorMessage, 'Failed');
          }
        });
      }
    },
    validateText(e) {
      let fieldName = e.target.name;
      let fieldValue = e.target.value;

      switch (fieldName) {
        case 'firstName':
          this.formData.firstName = fieldValue;
          if (fieldValue.trim() === '' || fieldValue.trim().length < 3) {
            this.error.firstNameError = true;
          } else {
            this.error.firstNameError = false;
          }
          break;

        case 'lastName':
          this.formData.lastName = fieldValue;
          if (fieldValue.trim() === '' || fieldValue.trim().length < 3) {
            this.error.lastNameError = true;
          } else {
            this.error.lastNameError = false;
          }
          break;

          // case 'emailAddress':
          //   this.formData.emailAddress = fieldValue;
          //   var emailFormat = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          //   if (fieldValue.match(emailFormat)) {
          //     this.error.emailAddressError = true;
          //   } else {
          //     this.error.emailAddressError = false;
          //   }
          //   break;

        case 'address':
          this.formData.address = fieldValue;
          if (fieldValue && fieldValue.trim().length < 3) {
            this.error.addressError = true;
          } else {
            this.error.addressError = false;
          }
          break;

        case 'phone':
          // var phoneFormat = /^\d+$/;
          var phoneFormat = /^\+?[0-9][0-9]{7,14}$/;
          this.formData.phone = fieldValue;
          // if (fieldValue.match(phoneFormat) && (fieldValue.length > 8 && fieldValue.length < 15) ) {
          if (fieldValue.match(phoneFormat)) {
            this.error.phoneError = false;
          } else {
            this.error.phoneError = true;
          }
          break;

        case 'bio':
          this.formData.bio = fieldValue;
          if (fieldValue && fieldValue.trim().length < 3) {
            this.error.bioError = true;
          } else {
            this.error.bioError = false;
          }
          break;

        case 'role':
          this.formData.role = fieldValue;
          if (fieldValue && fieldValue.trim().length < 3) {
            this.error.roleError = true;
          } else {
            this.error.roleError = false;
          }
          break;

        case 'country':
          this.formData.country = fieldValue;
          if (fieldValue && fieldValue.trim().length < 3) {
            this.error.countryError = true;
          } else {
            this.error.countryError = false;
          }
          break;

        case 'state':
          this.formData.state = fieldValue;
          if (fieldValue && fieldValue.trim().length < 3) {
            this.error.stateError = true;
          } else {
            this.error.stateError = false;
          }
          break;

        case 'city':
          this.formData.city = fieldValue;
          if (fieldValue && fieldValue.trim().length < 3) {
            this.error.cityError = true;
          } else {
            this.error.cityError = false;
          }
          break;
      }
    },
    selectedFile(file) {
      if(file.name === 'cv'){
        this.formData.selectedCvFile = file.value;
      } else if(file.name === 'video') {
        this.formData.selectedVideoFile = file.value;
      }
      return this.formData;
    },
    closePasswordSettings() {
      this.settingsOption = false;
    },
    setCvErrorStatus(value) {
      value === true ? this.selectedCVError = true : this.selectedCVError = false;
    },
    setVideoErrorStatus(value) {
      value === true ? this.selectedVideoError = true : this.selectedVideoError = false;
    }
  },
};

</script>

<style scoped>
  .settings-option-buttons button {
    min-width: 240px;
    background: #F1F1F1;
    border-radius: 5px;
    font-family: 'montserrat';
    font-style: normal;
    font-weight: 500;
    outline: none;
    font-size: 1.15rem;
    line-height: 24.38px;
    color: hsl(0, 7%, 48%);
    padding: 15px 30px;
  }
  .settings-option-buttons .firstOption {
    margin-right: 70px;
  }
  .active {
    background: #025fa0 !important;
    color: white !important;
  }
  .applicant-details-option-holder{
    background: var(--white);
    box-shadow: 0px 0px 4px 2px rgba(180, 180, 180, 0.15);
    border-radius: 15px;
    margin-top: 40px;
    padding: 40px;
  }
  .applicant-details-option {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}
  .container-left, .container-right {
    width: 45%;
  }
  h3 {
    font-family: 'montserrat';
    font-style: normal;
    font-weight: 600;
    font-size: 1rem;
    line-height: 21.94px;
    color: var(--colorSecondary);
  }
  p {
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;
    color: #5B5B5B;
    margin-top: 17px;
  }
  input, textarea {
    width: 100%;
    height: 50px;
    box-shadow: 0px 0px 4px 2px rgba(39, 31, 31, 0.15);
    border-radius: 5px;
    outline: none;
    padding: 10px;
    font-family: 'montserrat';
    font-size: 1rem;
    color: rgba(51, 52, 54, 0.7);
    line-height: 1.25rem;
    -webkit-appearance: auto;
    color: rgba(51, 52, 54, 0.7);
    margin-top: 13px;
  }
  textarea {
    resize: none;
    height: 150px;
    line-height: 31px;
  }
  .input-holder {
    margin-bottom: 35px;
  }
  .input-holder .header {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
  .input-holder p.error {
    font-size: 14px;
    color: tomato;
  }
  .state-and-city-holder {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
  .state-and-city-holder > div {
    width: 48%;
  }
  .buttons {
    display: flex;
    justify-content: right;
    margin: 60px 0 40px 0;
  }
  .security-buttons {
    display: flex;
    margin-top: 40px;
  }
  .buttons button, .security-buttons button {
    border-radius: 5px;
    padding: 15px 50px;
    font-weight: 800;
    outline: none;
    min-width: 180px;
  }
  .buttons .update-btn, .security-buttons .update-btn {
    background: var(--colorPrimary);
    box-shadow: 0px 9px 29px rgba(26, 107, 158, 0.1);
    color: var(--white);
    outline: none;
  }
  .buttons .cancel-btn, .security-buttons .cancel-btn {
    color: #252525;
    box-sizing: border-box;
    box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.15);
    outline: none;
    margin-right: 40px;
  }


  /* Responsiveness */

  @media only screen and (max-width: 1080px) {
    .applicant-details-option {
      flex-direction: column;
    }
    .container-left, .container-right {
      width: 100%;
    }
  }
  @media only screen and (max-width: 565px) {
    .settings-option-buttons button {
      width: 100%;
    }
    .buttons button, .security-buttons button {
      width: 160px;
      margin: 10px 0 !important;
    }
    .buttons {
      margin: 0 auto;
      flex-direction: column;
      align-items: center;
    }
  }
  @media only screen and (max-width: 480px) {
    .applicant-details-option, .security-option {
      padding: 40px 20px;
    }
  }
  @media only screen and (max-width: 370px) {
    .state-and-city-holder {
      flex-direction: column;
    }
    .state-and-city-holder > div {
      width: 100%;
    }
  }
</style>
